import useAssistantPanelSendPrompt from "components/AssistantPanel/hooks/useSendPrompt";
import useAssistantPanelAnalytics from "components/AssistantPanel/analytics/useAnalytics";
import useRunSummary from "components/RunSummarization/hooks/useRunSummary";
import { buildRunSummaryPrompt } from "components/RunSummarization/prompts";
import RunSummarizationTrigger from "components/RunSummarization/RunSummarizationTrigger";
import Box from "ds/components/Box";
import Typography from "ds/components/Typography";
import useAnalytics from "hooks/useAnalytics";

type ExplainRunButtonProps = {
  stackId: string;
  runId: string;
};

const ExplainRunButton = ({ stackId, runId }: ExplainRunButtonProps) => {
  const { openPrompt, isChatOpen } = useAssistantPanelSendPrompt();
  const trackSegmentAnalyticsEvent = useAnalytics();
  const { trackConversationOpened } = useAssistantPanelAnalytics();

  const { canTriggerSummary, showSummarizerTrigger } = useRunSummary();

  const generateTooltipMessage = () => {
    if (!canTriggerSummary.result && canTriggerSummary.message) {
      return canTriggerSummary.message;
    }

    return (
      <Box direction="column" gap="small">
        <Typography tag="p">Ask Infra Assistant</Typography>
        <Typography tag="p">
          Infra Assistant combines information from <b>all execution phases</b> to give a
          comprehensive run summary, which may take longer to process than the phase summaries.
        </Typography>
      </Box>
    );
  };

  const handleAssistantTrigger = () => {
    trackSegmentAnalyticsEvent("Run Logs - AI Run Suggestions Clicked", {
      stackId,
      runId,
      via: "assistant",
    });

    trackConversationOpened("run_summarization");

    const prompt = buildRunSummaryPrompt({ stackId, runId });

    openPrompt(prompt, { newChat: !isChatOpen });
  };

  if (!showSummarizerTrigger) {
    return null;
  }

  return (
    <Box>
      <RunSummarizationTrigger
        onPress={handleAssistantTrigger}
        disabled={!canTriggerSummary.result}
        tooltipText={generateTooltipMessage()}
      >
        Explain
      </RunSummarizationTrigger>
    </Box>
  );
};

export default ExplainRunButton;
